import React from 'react';
import { SettingsLink } from 'components/Navigation';
import { paths } from 'constants';

const PersonalDetailsLink = () => (
  <SettingsLink
    path={paths.Personal}
    label="Personal details"
    classNames="nav__personal-link"
  />
);

export default PersonalDetailsLink;
